import { useStaticQuery, graphql } from "gatsby"

export default function useHeroSmokeImages() {
  const query = useStaticQuery(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/0_hero_images/hero_image_1920.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/0_hero_images/hero_image_1440.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/0_hero_images/hero_image_768.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const images = Object.keys(query).reduce((acc, current) => {
    acc[current] = query[current].childImageSharp.fluid
    return acc
  }, {})

  return images
}
